import { aboutData } from '@/mocks/homepage';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20reading%20scene%20with%20a%20person%20reading%20manga%20on%20a%20tablet%20by%20a%20window%20with%20soft%20sunlight%2C%20plants%20and%20a%20cup%20of%20tea%20nearby%2C%20comfortable%20atmosphere%2C%20artistic%20photography%20style%2C%20warm%20tones&width=800&height=600&seq=about-manga-01&orientation=landscape"
                alt="番茄漫画阅读场景"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:w-1/2">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
              {aboutData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.content}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {['韩漫精选', '日漫经典', '国漫原创', '每日更新', '永久免费'].map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}